@let canViewSidenav = canViewSidenav$ | async;
<div class="flex flex-col h-full">
  @if (canViewSidenav) {
    <aside
      class="sidenav-aside"
      [class.sidenav-aside--open]="sidenavOpen()"
      [class.sidenav-aside--mobile]="isMobile()"
      [class.sidenav-aside--overlay]="sidenavMode() === 'over'"
      [class.sidenav-aside--animate]="enableAnimation()"
    >
      <app-sidenav [isMobile]="isMobile()" [isCollapsed]="isCollapsed()" (navItemClicked)="closeSidenav()"></app-sidenav>
    </aside>
    @if (sidenavMode() === 'over' && sidenavOpen()) {
      <div class="sidenav-backdrop" (click)="closeSidenav()"></div>
    }
  }
  <main class="flex flex-col flex-1 bg-[#eee] overflow-x-hidden" [class.has-sidenav]="canViewSidenav">
    <app-topbar [isMobile]="isMobile()" (toggleSidenav)="toggleSidenav()"></app-topbar>
    <div class="flex flex-col flex-1">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>

<app-spotlight></app-spotlight>
